import React, { useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { ThankYouFields, ThankYouTitle } from 'src/components';
import { getTrackingForm, useTrackingManager } from 'src/feature-app';
import { useIsComerciales } from 'src/feature-app/hooks';
import { RenderController } from 'src/feature-app/Screen';
import { DealersInfo, FormDataFields, FormInfo, OneFormState, Steps } from 'src/types';
interface ThankYouProps {
	formData: FormDataFields;
	formInfo: FormInfo;
	dealersInfo: DealersInfo;
	inPage?: boolean;
}

function ThankYouLeads(props: ThankYouProps) {
	const { dealersInfo, inPage } = props;
	const { formInfo, formData } = useSelector((state: OneFormState) => state);
	const { formResponse } = formInfo;
	const { modelo, formName, name: nombre } = formData.fields;
	const { oferta, match } = dealersInfo;

	const dispatch = useDispatch();
	const isComerciales = useIsComerciales();
	const trackingManager = useTrackingManager();

	const [selectedCopies, setSelectedCopies] = useState<any>(null);
	const [boldCopySecond, setBoldCopySecond] = useState(null);
	const [bodyCopy, setBodyCopy] = useState<string>('');
	const [ctaUrl, setCtaUrl] = useState(null);

	const thankYouCopies = [
		{
			name: 'lead-oferta',
			titleCopyRegular: isComerciales ? '¡Muchas gracias por tu interés!' : 'Estás muy cerca de conducir',
			titleCopyBold: isComerciales ? '' : 'tu ',
			bodyCopy: isComerciales ? 'En breve te llamaremos desde un número terminado en 904.' : 'Un asesor contactará contigo muy pronto para darte todos los detalles sobre esta oferta.',
		},
		{
			name: 'lead-cita',
			titleCopyRegular: 'Te esperamos en',
			titleCopyBold: '',
			bodyCopy: 'Ya hemos recibido tu solicitud, %name%. Muy pronto, un asesor contactará contigo para terminar de cerrar tu cita.',
		},
		{
			name: 'lead-presupuesto',
			titleCopyRegular: 'Pronto recibirás',
			titleCopyBold: 'el presupuesto para tu ',
			bodyCopy: 'Un asesor contactará contigo para hacerte llegar la información que necesitas.',
		},
		{
			name: 'lead-match',
			titleCopyRegular: 'Estás muy cerca de conducir',
			titleCopyBold: 'tu ',
			bodyCopy: 'Un asesor contactará muy pronto contigo para hacerte una oferta a medida.',
		},
		{
			name: 'lead-mas_informacion',
			titleCopyRegular: 'Pronto recibirás',
			titleCopyBold: 'más información sobre el ',
			bodyCopy: 'Un asesor contactará contigo para responder a todas tus preguntas.',
		},
		{
			name: 'lead-stock',
			titleCopyRegular: 'Pronto ',
			titleCopyBold: 'responderemos a tus preguntas',
			bodyCopy: 'Un asesor contactará contigo para explicártelo todo sobre nuestros modelos con disponibilidad inmediata.',
		},
		{
			name: 'lead-test_drive',
			titleCopyRegular: 'Te esperamos en',
			titleCopyBold: '',
			bodyCopy: 'Un asesor te llamará pronto para terminar de confirmar contigo los detalles de la prueba de conducción.',
		},
		{
			name: 'lead-vo',
			titleCopyRegular: 'Muy pronto recibirás ',
			titleCopyBold: 'noticias sobre tu próximo Volkswagen de ocasión',
			bodyCopy: 'Un asesor contactará contigo para darte toda la información que necesites.',
		},
		{
			name: 'lead-call_center',
			titleCopyRegular: 'Lead enviado a',
			titleCopyBold: '',
			bodyCopy: 'Un asesor contactará con el lead para responder a sus preguntas.',
		},
	];

	useEffect(() => {
		// Thank you page no es gestionado como un step pero sí lo haremos en la analítica. Por eso Modificamos formInfo después del submit y antes del RESET
		const screenIndexThankyou = formInfo.numberOfScreens;

		dispatch({ type: 'SET_FORM_SUBMITTED', payload: true });
		dispatch({ type: 'SET_FORM_INFO', payload: { step: { screenIndex: screenIndexThankyou, name: 'ThankYou' } } });

		const copy = thankYouCopies.find((a: any) => formName.includes(a.name));
		setSelectedCopies(copy);

		trackingManager.trackFormSubmissionSuccessMessageLoad(
			{
				contentId: undefined,
			},
			getTrackingForm(formResponse),
		);
	}, []);

	useEffect(() => {
		if (selectedCopies) {
			if (nombre) {
				setBodyCopy(selectedCopies.bodyCopy.replace('%name%', nombre));
			} else {
				setBodyCopy(selectedCopies.bodyCopy.replace(', %name%', ''));
			}
		}
	}, [selectedCopies, nombre]);

	useEffect(() => {
		if (dealersInfo) {
			if (oferta && formName === 'lead-oferta') {
				setBoldCopySecond(oferta.carline.title);
			} else if (match && formName === 'lead-match') {
				setBoldCopySecond(match.carline.title);
			} else if (formName.startsWith('lead-cita') || formName.startsWith('lead-test_drive') || formName.startsWith('lead-call_center')) {
				setBoldCopySecond(dealersInfo.selectedInstallation?.VGED_CommercialName__c);
			}
		}
	}, [dealersInfo]);

	useEffect(() => {
		if (formName.startsWith('lead-presupuesto') || formName.startsWith('lead-mas_informacion')) {
			setBoldCopySecond(modelo ? modelo : 'coche');
		}
	}, [modelo]);

	useEffect(() => {
		if (oferta && formName === 'lead-oferta') {
			if (isComerciales) {
				setCtaUrl(`https://www.volkswagen-comerciales.es/es/modelos/${oferta.carline.name}.html`);
			} else {
				setCtaUrl(`https://www.volkswagen.es/es/modelos/${oferta.carline.name}.html`);
			}
		} else if (match && formName === 'lead-match') {
			setCtaUrl(`https://www.volkswagen.es/es/modelos/${match.carline.name}.html`);
		}
	}, [dealersInfo]);

	const screen: Steps = {
		title: <ThankYouTitle regularCopyFirst={selectedCopies?.titleCopyRegular} boldCopyFirst={selectedCopies?.titleCopyBold} boldCopySecond={boldCopySecond} />,
		fields: <ThankYouFields copyBook={bodyCopy} ctaUrl={ctaUrl} />,
	};

	return <RenderController screenType={inPage ? 'full-screen' : 'layer-screen'} title={screen.title} fields={screen.fields} key={555} avoidTrackFormStepLoad />;
}

const mapStateToProps = (state: OneFormState) => {
	return {
		formData: state.formData.fields,
		formInfo: state.formInfo,
		dealersInfo: state.dealersInfo,
	};
};

const ConnectedComponent = connect(mapStateToProps)(ThankYouLeads);

export { ConnectedComponent as ThankYouLeads };
